import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_DELETE_USER_SERVER } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteUser = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [deleteOrgUser, res] = esApi.endpoints.deleteOrgUser.useMutation()

  const deleteUser = useCallback(
    async (userId: number): Promise<boolean> => {
      try {
        await deleteOrgUser({
          orgId: orgId.toString(),
          userId: userId.toString(),
        }).unwrap()

        dispatch(
          createNotification({
            'delete-user-success': {
              type: 'success',
              message: 'Removed user from the organization successfully.',
            },
          }),
        )

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'delete-user-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_DELETE_USER_SERVER),
            },
          }),
        )

        return false
      }
    },
    [orgId, dispatch, deleteOrgUser],
  )

  return [deleteUser, res] as const
}
